import React from "react";
import { motion } from "framer-motion";
import { Inline } from "./Inline";
import { Eye, Lightbulb, ScrollText } from "lucide-react";

const CONFIG = {
  pic: {
    label: "The picture",
    lead: "The picture:",
    icon: Eye,
    accent: "#1C2430",
    bg: "rgba(28,36,48,0.03)",
  },
  mn: {
    label: "Memory trick",
    icon: Lightbulb,
    accent: "#D26040",
    bg: "rgba(210,96,64,0.06)",
  },
  rule: {
    label: "Exam rules",
    icon: ScrollText,
    accent: "#2F6F4F",
    bg: "rgba(47,111,79,0.06)",
  },
};

export function Callout({ variant, children, text }) {
  const cfg = CONFIG[variant];
  const Icon = cfg.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="my-8 border-l-[3px] pl-6 pr-5 py-5"
      style={{ borderColor: cfg.accent, background: cfg.bg }}
      data-testid={`callout-${variant}`}
    >
      <div
        className="font-mono-ui text-[10px] font-bold uppercase tracking-[0.22em] mb-3 flex items-center gap-2"
        style={{ color: cfg.accent }}
      >
        <Icon size={13} strokeWidth={2.2} />
        {cfg.label}
      </div>
      <p className="text-[15.5px] leading-relaxed text-[#1C2430]/85">
        {cfg.lead && <span className="font-bold text-[#1C2430]">{cfg.lead} </span>}
        <Inline text={text} />
        {children}
      </p>
    </motion.div>
  );
}
